import PrimaryButton from "../../components/Buttons/PrimaryButton";
import Product from "../../ts/models/Products";
import { getClasses } from "../../utils";
import classes from "./ProductsSelectionCard.module.css";

type Props = {
  data: Product;
  added: boolean;
  onAddRemove: (id: string) => void;
};

const ProductsCard: React.FC<Props> = ({ data, added, onAddRemove }) => {
  return (
    <div
      className={getClasses(classes.main, added ? classes.selectedCard : "")}
      onClick={() => onAddRemove(data.id)}
    >
      <div>
        <div className={classes.heading}>{data.name}</div>
        <div className={classes.description}>{data.description}</div>
      </div>
      <div>
        <PrimaryButton
          name={added ? "REMOVE" : "ADD"}
          onClick={(e) => {
            onAddRemove(data.id);
            e.stopPropagation();
          }}
          className={getClasses(classes.addBtn, added ? classes.removeBtn : "")}
        />
      </div>
    </div>
  );
};

export default ProductsCard;
